module.exports = __webpack_public_path__ + "img/no_choose.53e667ce.svg";